var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_88_277",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_88_277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.6875C9.45 18.6958 8.24688 17.9375 6.89062 17.4125C5.53437 16.8875 4.1125 16.625 2.625 16.625V7C4.09792 7 5.5125 7.26615 6.86875 7.79844C8.225 8.33073 9.43542 9.1 10.5 10.1062C11.5646 9.1 12.775 8.33073 14.1313 7.79844C15.4875 7.26615 16.9021 7 18.375 7V16.625C16.8729 16.625 15.4474 16.8875 14.0984 17.4125C12.7495 17.9375 11.55 18.6958 10.5 19.6875ZM10.5 17.4125C11.4187 16.7271 12.3958 16.1802 13.4313 15.7719C14.4667 15.3635 15.5312 15.0938 16.625 14.9625V8.925C15.5604 9.11458 14.5141 9.4974 13.4859 10.0734C12.4578 10.6495 11.4625 11.4188 10.5 12.3813C9.5375 11.4188 8.54219 10.6495 7.51406 10.0734C6.48594 9.4974 5.43958 9.11458 4.375 8.925V14.9625C5.46875 15.0938 6.53333 15.3635 7.56875 15.7719C8.60417 16.1802 9.58125 16.7271 10.5 17.4125ZM10.5 7.875C9.5375 7.875 8.71354 7.53229 8.02813 6.84688C7.34271 6.16146 7 5.3375 7 4.375C7 3.4125 7.34271 2.58854 8.02813 1.90313C8.71354 1.21771 9.5375 0.875 10.5 0.875C11.4625 0.875 12.2865 1.21771 12.9719 1.90313C13.6573 2.58854 14 3.4125 14 4.375C14 5.3375 13.6573 6.16146 12.9719 6.84688C12.2865 7.53229 11.4625 7.875 10.5 7.875ZM10.5 6.125C10.9812 6.125 11.3932 5.95365 11.7359 5.61094C12.0786 5.26823 12.25 4.85625 12.25 4.375C12.25 3.89375 12.0786 3.48177 11.7359 3.13906C11.3932 2.79635 10.9812 2.625 10.5 2.625C10.0188 2.625 9.60677 2.79635 9.26406 3.13906C8.92135 3.48177 8.75 3.89375 8.75 4.375C8.75 4.85625 8.92135 5.26823 9.26406 5.61094C9.60677 5.95365 10.0188 6.125 10.5 6.125Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIcon);
export default __webpack_public_path__ + "static/media/testIcon.3703b028cc16a1585d64c6b05983b7ea.svg";
export { ForwardRef as ReactComponent };